import { createFileRoute, Link } from '@tanstack/react-router';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Home, ArrowBack } from '@mui/icons-material';

export const Route = createFileRoute('/404')({
  component: NotFoundComponent,
});

function NotFoundComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: { xs: '90%', sm: 500 },
        }}
      >
        <Typography
          variant='h1'
          component='h1'
          sx={{
            fontSize: '6rem',
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 2,
          }}
        >
          404
        </Typography>

        <Typography variant='h5' component='h2' gutterBottom>
          Page Not Found
        </Typography>

        <Typography variant='body1' color='text.secondary' paragraph>
          The page you're looking for doesn't exist or has been moved.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
          <Button
            component={Link}
            to='/'
            variant='contained'
            startIcon={<Home />}
          >
            Go Home
          </Button>

          <Button
            onClick={() => window.history.back()}
            variant='outlined'
            startIcon={<ArrowBack />}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
